import ServiceGroup from "../models/servicegroup.model";

/**
 * Read a person service group retrieved from the backend.
 * @param {Object} o
 * @return {ServiceGroup}
 */
function readServiceGroup(o) {
  return new ServiceGroup(o.id, o.name, o.order_number);
}

export {
  readServiceGroup
};
